'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

require('slick-carousel');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var slickSettings = {
  rows: 0,
  mobileFirst: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  centerMode: false,
  arrows: true,
  prevArrow: '[data-see-it-styled-control-prev]',
  nextArrow: '[data-see-it-styled-control-next]',
  centerPadding: '15px',
  lazyLoad: 'progressive',
  responsive: [{
    breakpoint: 500,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      centerMode: false,
      centerPadding: 0,
      infinite: true
    }
  }, {
    breakpoint: 768,
    settings: {
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      centerMode: false,
      centerPadding: 0,
      infinite: true
    }
  }]
};

var initSlider = function initSlider() {
  if ($('[data-see-it-styled-slider]').length) {
    $('[data-see-it-styled-slider]').slick(slickSettings);
  }
};

/** @private */
var getURI = function getURI(handle) {
  var collection = window.bvaccel.collection.handle ? '/collections/' + window.bvaccel.collection.handle : '';
  var path = (collection + '/products/' + handle).replace(/\/{2,}/, '/'); // get rid of double slashes

  return path + '?view=ajax-product-see-it-styled';
};

/**
 * @public
 * @param {String} handle
 * @returns {Promise}
 */
var update = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(handle) {
    var options, uri, html, el;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(window.bvaccel.state.product.quickViewOpen || !handle)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt('return');

          case 2:
            options = {
              credentials: 'include'
            };
            uri = getURI(handle);
            _context.next = 6;
            return fetch(uri, options).then(function (res) {
              return res.text();
            }).catch(function (error) {
              throw new Error({ error: error, message: 'Error getting see it styled content.' });
            });

          case 6:
            html = _context.sent;


            if (html.includes('data-see-it-styled')) {
              el = document.querySelector('[data-see-it-styled]');


              if (el && html) {
                el.outerHTML = html;
              }

              initSlider();
            }

          case 8:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function update(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.default = {
  update: update,
  init: initSlider
};